
import { useSelector } from 'react-redux';
import { RootState } from '@/AppRedux/reducers';

const useAuthState = () => {
  const authState = useSelector((state: RootState) => state.auth);
  return authState;
};

export default useAuthState;
